import { isLocationCode, normalizeLocationCode } from '@/pages/fulfillment/inventory/inventoryView';

/** Single hyphens only, so WH#00 and MULTI--1 are never a second spelling of a shelf. */
const SHELF_GROUPS = /^[A-Z0-9]+(?:-[A-Z0-9]+)*$/;

/** Four digits in a row read as a scan: with this, none of about 208,000 codes in BigQuery passed and 410 of 412 stock locations did (2026-11-02). */
const READS_AS_A_SCAN = /\d{4}/;

/** PACKING is the packing desk and UNASSIGNED is no location; as an order's Shelf, PACKING would end the desk's "Scan the shelf" reminder [SSD-7817]. */
const NO_SHELF_WORDS = new Set(['PACKING', 'UNASSIGNED']);

/** One sentence each screen shows, so the rule reads the same wherever a code is refused. */
export const SHELF_CODE_RULE =
  'Use letters, digits and single hyphens, with at least one letter and up to 3 digits in a row, such as A5, MD-1-504, MULTI-1 or FLOOR. PACKING and UNASSIGNED are not shelves.';

/** A spaced name or a no-shelf word stays in the Shelf box with the reason instead of going to order search. */
export const readsAsAName = (value: string): boolean =>
  (/\s/.test(value.trim()) && !READS_AS_A_SCAN.test(value)) || NO_SHELF_WORDS.has(normalizeLocationCode(value));

/** The shelf a text names in the server's spelling or null, so a new area such as MULTI-1 needs no change here [SSD-7226 D2, SSD-7817]. */
export const readShelfCode = (value: string): string | null => {
  const code = normalizeLocationCode(value);
  const isShelf =
    isLocationCode(code) &&
    SHELF_GROUPS.test(code) &&
    /[A-Z]/.test(code) &&
    !READS_AS_A_SCAN.test(code) &&
    !NO_SHELF_WORDS.has(code);
  return isShelf ? code : null;
};
